import { useQueryClient } from "@tanstack/vue-query";

import { queries } from "~/queries";
import type { AuthProvider } from "~/types/Auth";

export default function () {
  const { loginWith, redirectCookie } = useAuth();
  const route = useRoute();
  const redirect = useRedirectPath();
  const queryClient = useQueryClient();
  const { onboardingEntry } = useOnboardingDialog();

  type Options = {
    provider: AuthProvider;
    loginHint?: string;
    redirectBackToCurrentPath?: boolean;
    reopenVerificationsDialog?: boolean;
  };

  const addClubToAutoFollow = async (categorySlug: string) => {
    if (onboardingEntry.value?.type) {
      try {
        const category = await queryClient.ensureQueryData({
          ...queries.categories.details(categorySlug),
          ...notFoundQueryOptions,
        });

        onboardingEntry.value.data = {
          id: category.id,
          name: categorySlug,
          followType: FollowFeatureType.Category,
          followSource: "onboarding",
          source: "LOGIN",
          ...onboardingEntry.value.data,
        };
      } catch (error) {
        const e = error as Error;
        //  FAN-1852: the backend is not sending us proper slugs so we can not automatically follow the club if the alternative name is not the slug
        if (e.message.includes("404")) {
          return;
        } else {
          throw error;
        }
      }
    }
  };

  const login = async (options: Options) => {
    const redirectPath = options.redirectBackToCurrentPath
      ? route.path
      : redirect?.getRedirectPath();

    const redirectQuery = options.reopenVerificationsDialog
      ? `?${OPEN_VERIFICATIONS_DIALOG_FLAG}=true`
      : "";

    redirectCookie.value = `${redirectPath}${redirectQuery}`;

    await loginWith({
      strategy: "sso",
      options: {
        provider: options.provider,
        loginHint: options.loginHint,
      },
    });
  };

  return {
    login,
    addClubToAutoFollow,
  };
}
